import SimpleTablePage from "../../common/SimpleTablePage";
import { Link } from "react-router";
import { Tag } from "antd";

const columns = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    ellipsis: true,
    width: 70,
    render: (id) => <Link to={`${id}`}>{id}</Link>,
  },
  {
    title: "Numero Seriale",
    dataIndex: "serialNumber",
    width: 200,
    ellipsis: true,
    key: "serialNumber",
  },
  {
    title: "Prodotto",
    dataIndex: ["product", "description"],
    width: 200,
    ellipsis: true,
    key: "description",
  },
  {
    title: "Stato",
    key: "assignmentStatus",
    width: 300,
    ellipsis: true,
    render: (record) => (
      <Tag color={record.assignmentStatus === "ASSIGNED" ? "blue" : "green"}>
        {record.assignmentStatus === "ASSIGNED"
          ? `Assegnato (${record.currentAssignment.employee.fullName})`
          : "Libero"}
      </Tag>
    ),
  },
];

export default function DpiInventoryUnits() {
  return (
    <SimpleTablePage
      title="Dpi tracciati"
      readOnly
      description="Gestici i DPI con matricola"
      resource={"dpiInventoryUnit"}
      columns={columns}
    />
  );
}
